<script>
export default {
  name: 'QkCirclePostManage',
  props: ['currentUser'],
  data() {
    return {
      param: {
        size: 10,
        circle_id: 0,
        post_status: '',
      },
      circle_id: 0,
      posts: [],
      postList: [],
      searchText: '',
      composing: false,
      typingTimer: null,
      loading: false,
      isDataEmpty: false,
      orderby: '',
      orderbyList: {
        '': '默认排序',
        date: '发布时间',
        comment_date: '回复时间',
        modified: '修改时间',
        random: '随机排序',
        comments: '评论数最多',
        views: '浏览数最多',
        like: '点赞数最多',
      },
      tabType: 'all',
      tabs: {
        all: '全部',
        pending: '待审核',
      },
      locked: false,
    };
  },
  computed: {
    emptyImg() {
      return `${qk_global.home_url}/wp-content/themes/mkua/Assets/fontend/images/empty.svg`;
    },
  },
  mounted() {
    if (typeof qk_circle !== 'undefined') {
      this.circle_id = this.param.circle_id = qk_circle.id;
    }

    if (!this.postList.length) {
      this.$refs.jsonPageNav.load(1, '', true);
    }
  },
  watch: {
    searchText() {
      this.searchText = this.searchText.trim();
      if (!this.searchText) {
        this.$refs.jsonPageNav.load(1, '', true);
      }
    },
  },
  methods: {
    changePosts(data) {
      this.postList = [];
      this.posts = data.data;
      this.postList = this.posts;
      this.loading = false;
      this.isDataEmpty = !this.postList.length;
    },
    changeTab(type, orderby = false) {
      if (type === this.tabType && !orderby) return;
      this.tabType = type;
      this.param.post_status = '';
      if (this.tabType === 'pending') {
        this.param.post_status = this.tabType;
      }

      this.$refs.jsonPageNav.pageCount = 1;
      this.loading = true;
      this.isDataEmpty = false;

      this.$nextTick(() => {
        this.$refs.jsonPageNav.load(1, '', true);
      });
    },
    changeOrderby(type) {
      this.param.orderby = this.orderby = type;
      this.changeTab(this.tabType, true);
    },
    handleInput() {
      if (this.searchText.trim()) {
        this.postList = [];
        this.loading = true;
      }
      if (!this.composing) {
        clearTimeout(this.typingTimer);
        this.typingTimer = setTimeout(() => {
          this.circleSearchPosts();
        }, 500);
      }
    },
    circleSearchPosts() {
      if (!this.searchText.trim()) return;
      this.loading = true;

      this.$https
        .post(`${qk_rest_url}getManageMomentList`, {
          search: this.searchText.trim(),
          circle_id: this.circle_id,
        })
        .then((res) => {
          this.postList = res.data.data;
          this.isDataEmpty = !this.postList.length;
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
          this.$message({ message: qkGetApiError(err, '操作失败'), type: 'error' });
        });
    },
    setMomentBest(item) {
      if (this.locked) return;
      this.locked = true;

      this.$http.post(`${qk_rest_url}setMomentBest`, `post_id=${item.id}`).then((res) => {
        this.$message({ message: res.data.message, type: 'success' });
        item.best = !item.best;
        this.locked = false;
      }).catch((err) => {
        this.locked = false;
        this.$message({ message: qkGetApiError(err, '操作失败'), type: 'error' });
      });
    },
    setMomentSticky(item) {
      if (this.locked) return;
      this.locked = true;

      this.$http.post(`${qk_rest_url}setMomentSticky`, `post_id=${item.id}`).then((res) => {
        this.$message({ message: res.data.message, type: 'success' });
        item.sticky = !item.sticky;
        this.locked = false;
      }).catch((err) => {
        this.locked = false;
        this.$message({ message: qkGetApiError(err, '删除失败'), type: 'error' });
      });
    },
    deleteMoment(item, index) {
      if (!confirm('确定要删除这个帖子吗？')) return;
      if (this.locked) return;
      this.locked = true;

      this.$http.post(`${qk_rest_url}deleteMoment`, `post_id=${item.id}`).then((res) => {
        this.$message({ message: res.data.message, type: 'success' });
        this.$nextTick(() => {
          this.postList.splice(index, 1);
          this.posts.splice(index, 1);
        });
        this.locked = false;
      }).catch((err) => {
        this.locked = false;
        this.$message({ message: qkGetApiError(err, '操作失败'), type: 'error' });
      });
    },
    changeMomentStatus(item) {
      if (this.locked) return;
      this.locked = true;

      this.$http.post(`${qk_rest_url}changeMomentStatus`, `post_id=${item.id}`).then(() => {
        this.$message({ message: '审核成功', type: 'success' });
        item.status = 'publish';
        item.status_name = '已发布';
        this.locked = false;
      }).catch((err) => {
        this.locked = false;
        this.$message({ message: qkGetApiError(err, '操作失败'), type: 'error' });
      });
    },
  },
};
</script>

<template>
  <div class="post-manage form-container">
    <form>
      <label class="form-item">
        <input
          v-model="searchText"
          class="input"
          type="text"
          autocomplete="off"
          maxlength="100"
          placeholder="搜索圈子内帖子"
          @input="handleInput"
          @compositionstart="composing = true"
          @compositionend="composing = false"
        />
        <span class="icon"><i class="ri-search-2-line"></i></span>
      </label>
    </form>
    <div v-if="!searchText" class="circle-tabs-nav">
      <div class="circle-tabs-nav-inner">
        <div class="tabs">
          <ul class="tabs-nav">
            <li
              v-for="(item, index) in tabs"
              :key="index"
              :class="{ active: tabType === index }"
              @click="changeTab(index)"
            >
              {{ item }}
            </li>
          </ul>
        </div>
        <div class="orderby-wrap">
          <div class="orderby">
            <span>默认排序</span>
            <i class="ri-arrow-down-s-line"></i>
          </div>
          <ul class="orderby-list box">
            <li
              v-for="(item, index) in orderbyList"
              :key="index"
              class="orderby-item"
              :class="{ active: orderby === index }"
              @click="changeOrderby(index)"
            >
              {{ item }}
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="post-list post-2">
      <ul v-if="postList.length" class="qk-grid scroll">
        <li v-for="(item, index) in postList" :key="item.id || index" class="post-list-item">
          <div class="item-in">
            <div v-if="item.attachment.image[0]" class="post-module-thumb">
              <div class="qk-radius post-thumbnail" style="padding-top: 65%">
                <div class="thumb-link">
                  <img class="post-thumb w-h qk-radius" :src="item.attachment.image[0].thumb" />
                </div>
              </div>
            </div>
            <div class="post-info">
              <h2 class="text-ellipsis">
                <span v-if="item.best" class="moment-best"></span>
                <span v-if="item.sticky" class="moment-sticky"></span>
                <span
                  v-if="item.status === 'pending'"
                  class="post-status"
                  :class="item.status"
                >
                  {{ item.status_name }}
                </span>
                <span v-html="item.title ? item.title : item.content"></span>
              </h2>
              <div class="post-info-buttom">
                <div class="buttom-left">
                  <span class="post-date" v-html="item.date"></span>
                  <span class="post-views">阅读 {{ item.meta.views }}</span>
                  <span class="comment">评论 {{ item.meta.comment }}</span>
                  <span class="like">喜欢 {{ item.meta.like.count }}</span>
                  <span class="collect">收藏 {{ item.meta.collect.count }}</span>
                </div>
                <div class="more-menu-box">
                  <div class="more-menu-icon">
                    <i class="ri-more-2-line"></i>
                  </div>
                  <ul class="more-menu-list box">
                    <li v-if="item.status === 'pending'" @click="changeMomentStatus(item)">通过审核</li>
                    <li @click="setMomentBest(item)">加精</li>
                    <li @click="setMomentSticky(item)">置顶</li>
                    <li @click="deleteMoment(item, index)">删除</li>
                    <li>编辑</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </li>
      </ul>
      <div v-else-if="loading && !postList.length" v-cloak class="loading empty"></div>
      <template v-else-if="isDataEmpty">
        <div class="empty">
          <img :src="emptyImg" class="empty-img" />
          <p class="empty-text">暂无数据</p>
        </div>
      </template>
    </div>
    <div class="qk-pagenav json-nav">
      <page-nav
        ref="jsonPageNav"
        paged="1"
        pages="1"
        navtype="json"
        type="page"
        :api="'getManageMomentList'"
        :param="param"
        v-once
        @change="changePosts"
      />
    </div>
  </div>
</template>
